import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { CloudWorkloadSecurityCustomerViewController } from '../controller/CloudWorkloadSecurityCustomerViewController';

export class CloudWorkloadSecurityCustomerViewWebComponent extends BaseWebComponentElement {
  public controller: CloudWorkloadSecurityCustomerViewController;

  constructor() {
    super();

    this.initialSetup({
      controllerConstructor: CloudWorkloadSecurityCustomerViewController,
    });
  }
}
